import Phaser from '../lib/phaser.js';

/**
 * Make a fixed design-space scene fill the real (RESIZE-mode) viewport.
 *
 * Several full-screen UI scenes (party, inventory, monster details, options, …) are authored
 * against a fixed design resolution — their backgrounds and every hardcoded coordinate live in
 * that space. The game runs `Phaser.Scale.RESIZE` at the full window size, so without a transform
 * the design-space layout only fills a small top-left chunk of the viewport (the "tiny UI in the
 * corner" bug). This scales + centers the scene camera so the WHOLE design space fits inside the
 * viewport at any window size, and re-fits on every RESIZE (auto-cleaned on scene shutdown).
 *
 * Mirrors BattleScene.#fitCameraToViewport so all full-screen scenes behave identically.
 *
 * @param {Phaser.Scene} scene
 * @param {number} designWidth
 * @param {number} designHeight
 * @returns {void}
 */
export function fitCameraToDesign(scene, designWidth, designHeight) {
  const fit = () => {
    const cam = scene.cameras.main;
    // CONTAIN fit: scale so the ENTIRE design space is visible (nothing cropped at any aspect), and
    // fill the leftover letterbox margins with a solid dark background. COVER-fit used to crop the
    // design space's longer axis — which pushed corner UI (e.g. the top-right ✕ close button) off
    // the centered layout and over the always-on currency HUD.
    const zoom = Math.min(scene.scale.width / designWidth, scene.scale.height / designHeight);
    cam.setZoom(zoom);
    cam.setBackgroundColor('#05080d');
    cam.centerOn(designWidth / 2, designHeight / 2);
  };

  fit();
  scene.scale.on(Phaser.Scale.Events.RESIZE, fit, scene);
  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    scene.scale.off(Phaser.Scale.Events.RESIZE, fit, scene);
  });
}
